export default __webpack_public_path__ + "static/media/img2.8e8730c9.png";